"use strict";

exports.__esModule = true;
exports.useSubscription = useSubscription;

var _react = require("react");

var _ApolloContext = require("./ApolloContext");

var _actHack = _interopRequireDefault(require("./internal/actHack"));

var _utils = require("./utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function useSubscription(query, _temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      onSubscriptionData = _ref.onSubscriptionData,
      overrideClient = _ref.client,
      options = _objectWithoutPropertiesLoose(_ref, ["onSubscriptionData", "client"]);

  var client = (0, _ApolloContext.useApolloClient)(overrideClient);
  var onSubscriptionDataRef = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)({
    loading: true
  }),
      result = _useState[0],
      setResultBase = _useState[1];

  onSubscriptionDataRef.current = onSubscriptionData;

  function setResult(newResult) {
    // A hack to get rid React warnings during tests.
    (0, _actHack.default)(function () {
      setResultBase(newResult);
    });
  }

  (0, _react.useEffect)(function () {
    if (options.skip === true) {
      return;
    }

    var subscription = client.subscribe(_extends({}, options, {
      query: query
    })).subscribe(function (nextResult) {
      var newResult = {
        data: nextResult.data,
        error: undefined,
        loading: false
      };
      setResult(newResult);

      if (onSubscriptionDataRef.current) {
        onSubscriptionDataRef.current({
          client: client,
          subscriptionData: newResult
        });
      }
    }, function (error) {
      setResult({
        loading: false,
        data: result.data,
        error: error
      });
    });
    return function () {
      setResult({
        loading: true
      });
      subscription.unsubscribe();
    };
  }, [query, options && (0, _utils.objToKey)(options)]);
  return result;
}


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/react-apollo-hooks/lib/useSubscription.js
// module id = 435
// module chunks = 178331994103267 231608221292675